<template>
  <div class="box">
    <!-- 顶部导航 start -->
    <nav-bar />
    <!-- banner start -->
    <banner
      :bannerSrc="require('../../assets/images/banner_5.png')"
      isnum="about"
    />
    <!-- 内容 -->
    <about-cat />
    <!-- 页脚 start -->
    <footers />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Banner from "@/components/Banner";
import Footers from "@/components/Footer";
import AboutCat from "./component/AboutCat";

export default {
  name: "AboutUs",
  components: {
    NavBar,
    Banner,
    Footers,
    AboutCat,
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  created() {
    this.$BackTop();
  },
  destroyed() {
    location.reload();
  },
  methods: {},
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/AboutUs/index.vue